<template>
    <div>
        <div class="iclassreport-body" v-if="showReport">
            <table class="quiz-table">
                <thead>
                    <tr>
                        <th>{{  $t('question_result') }}</th>
                        <th>{{  $t('total_score') }}</th>
                        <th>{{  $t('status') }}</th>
                        <th v-for="(question, index) in quizData" :key="index">
                            {{ "Q" + (index + 1) }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <span class="wrong-answer">{{ totalWrong }}</span> |
                            <span class="correct-answer">{{ totalCorrect }}</span>
                            <br/>
                            <span class="legend">
                                <span class="wrong-answer">{{  $t('incorrect') }}</span> |
                                <span class="correct-answer">{{  $t('correct') }}</span>
                            </span>
                        </td>
                        <td>{{ totalPoint }}/{{ maxPoint }}<br>({{ convertTime(totalTime) }})</td>
                        <td :class="finalResult.color">{{ $t(finalResult.status) }}</td>
                        <td v-for="(question, index) in questionData" :key="index">
                            <span v-if="question.point > 0" class="correct-answer">{{ question.point }}</span>
                            <span v-else-if="question.point === -1">-</span>
                            <span v-else class="wrong-answer">0</span>
                            <br/><span :class="getClassTime">({{ convertTime(question.time) }})</span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="comment" :class="finalResult.color">
                <span class="status0">{{  $t('feedback_sugest') }}: </span>{{  $t(finalResult.comment) }}
            </div>
        </div>
        <div v-else>
            <div class="status0 p-5">{{  $t('no_data_report_content') }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        quizData: {
            type: Array,
            required: true,
        },
        isActive: {
            type: Boolean,
            require: true
        }
    },
    computed: {
        getClassTime() {
            if (this.questionData.length <= 8) {
                return "time-0";
            } else if (this.questionData.length <= 10) {
                return "time-1";
            } else {
                return "time-2";
            }
        },
        finalResult() {
            if (this.percentage < 0.4) {
                return {status: 'not_achieved', color: 'status1', comment: 'quiz_session_comment_not_achieved'};
            } else if (this.percentage < 0.6) {
                return {status: 'achieved', color: 'status2', comment: 'quiz_session_comment_achieved'};
            } else if (this.percentage < 0.8) {
                return {status: 'good', color: 'status3', comment: 'quiz_session_comment_good'};
            } else {
                return {status: 'very_good', color: 'status4', comment: 'quiz_session_comment_very_good'};
            }
        },
    },
    methods: {
        parseScore(value) {
            if (!value || value === "-") return 0;
            const num = parseFloat(value);
            return isNaN(num) ? 0 : num;
        },
        convertTime(value) {
            return Math.floor(value / 60) + "m " + (value % 60) + "s";
        },
    },
    mounted() {
        if (this.quizData && this.quizData.length && this.isActive) {
            this.showReport = true;
            for (const item of this.quizData) {
                this.maxPoint += item.point;
                if (item.answers && item.answers.length) {
                    let sum = 0, correct = 0;
                    for (const answer of item.answers) {
                        sum += answer.point;
                        correct += answer.isCorrect;
                    }
                    if (correct == item.totalCorrectAnswer) {
                        this.totalCorrect++;
                        sum = Math.round(sum * 2) / 2;
                        this.totalPoint += sum;
                        this.totalTime += item.totalTime;
                        this.questionData.push({point: sum, time: item.totalTime});
                    } else {
                        this.totalWrong++;
                        this.questionData.push({point: 0, time: 0});
                    }
                } else {
                    this.totalWrong++;
                    this.questionData.push({point: -1, time: 0});
                }
            }
            this.totalWrong += this.totalAlmost;
            this.percentage = this.totalPoint / this.maxPoint;
        }
    },
    data() {
        return {
            showReport: false,
            questionData: [],
            totalPoint: 0,
            totalTime: 0,
            totalCorrect: 0,
            totalAlmost: 0,
            totalWrong: 0,
            maxPoint: 0,
            percentage: 0,
        };
    },
};
</script>

<style scoped>
.iclassreport-body {
    margin: 20px 77px;
}

.quiz-table {
    margin: 0 auto;
    border-collapse: collapse;
    background: #fff;
    text-align: center;
    vertical-align: middle;
    color: #000;
    font-size: 13px;
}

.quiz-table th,
.quiz-table td {
    border: 1px solid #2F66C9;
    padding: 8px;
    text-align: center;
    font-size: 13px;
}

.status0 {
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    color: #000000;
}

.status1 {
    color: #FF0000;
    font-weight: bold;
}

.status2 {
    color: #7158C2;
    font-weight: bold;
}

.status3 {
    color: #FFA800;
    font-weight: bold;
}

.status4 {
    color: #28A745;
    font-weight: bold;
}

.correct-answer {
    color: #28A745;
    font-weight: bold;
}

.almost-answer {
    color: #FFA800;
    font-weight: bold;
}

.wrong-answer {
    color: #FF0000;
    font-weight: bold;
}

.legend {
    font-size: 10px;
    font-weight: normal;
}

.time-0 {
    font-size: 13px;
}

.time-1 {
    font-size: 12px;
}

.time-2 {
    font-size: 10px;
}

.comment {
    font-size: 14px;
    font-weight: bold;
    margin-top: 20px;
    text-align: center;
}
</style>